import { MediaAsset } from '@/libs/contentful/types';
import { ColorwayLike } from './types';
import { isDarkColorway } from './constants';

export interface HeaderImageSelection {
  media: MediaAsset | undefined;
  fieldName: 'headerImage' | 'headerImageOnLight';
}

export function getHeaderImageSelection({
  backgroundColor,
  headerImageOnDark,
  headerImageOnLight,
}: {
  backgroundColor: ColorwayLike;
  headerImageOnDark: MediaAsset | undefined;
  headerImageOnLight: MediaAsset | undefined;
}): HeaderImageSelection {
  if (isDarkColorway(backgroundColor)) {
    return {
      media: headerImageOnDark ?? headerImageOnLight,
      fieldName: headerImageOnDark ? 'headerImage' : 'headerImageOnLight',
    };
  }

  return {
    media: headerImageOnLight ?? headerImageOnDark,
    fieldName: headerImageOnLight ? 'headerImageOnLight' : 'headerImage',
  };
}
